import React, { useEffect, useState } from "react";
import {
  Layout, Menu, Card, Row, Col, Tabs, Table, Progress, Statistic,
  Button as AntdButton, DatePicker, Checkbox
} from "antd";
import { Chart } from "react-google-charts";
import api from '../config.json';
import axios from '../httpServices/httpService';
import swal from "sweetalert";
import moment from "moment";
import Loading from "../utill/LoadingComponent";
import { Grid, Paper, Typography } from "@mui/material";
import { cloneDeep } from "lodash";

const { RangePicker } = DatePicker;
const { Header, Content } = Layout;

const OverviewDashboard = () => {
  const [resData, setResData] = useState({ Alerts: [], AlertTypes: [] });
  const [inputData, setInputData] = useState({
    IsLive: false,
    From: new Date(),
    Till: new Date(),
  });
  const [loader, setLoader] = useState(false);
  const [storageData, setStorageData] = useState({ ImagesByFolder: [] });
  const [chartData, setChartData] = useState([]);

  const storage = parseInt(localStorage.getItem("islive"));

  useEffect(() => {
    if (storage) {
      setInputData((prev) => ({
        ...prev,
        IsLive: true,
      }));
    }
  }, [storage]);

  useEffect(() => {
    let intervalId;
    let isMounted = true;

    if (inputData.IsLive) {
      intervalId = setInterval(() => {
        getDashbaordData1(isMounted);
      }, 150000); // 5 * 30 * 1000
    }

    return () => {
      isMounted = false;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [inputData.IsLive]);

  useEffect(() => {
    let isMounted = true;
    getDashbaordData(isMounted);
    return () => {
      isMounted = false;
    };
  }, []);

  const getDashbaordData = async (isMounted = true) => {
    setLoader(true);
    let res = { data: { ...storageData } };

    try {
      res = await axios.get(api.api + "ImagesFromS3");
    } catch (err) {
      console.log(`${err}`);
    }

    axios
      .put(api.api + "OverviewDashbaord", inputData)
      .then((result) => {
        if (!isMounted) return;

        setLoader(false);
        const chart = [["Result", "Number Of Reports"]];
        chart.push(["OK", result.data.OK_Inspection]);
        chart.push(["NG", result.data.NG_Inspection]);

        setStorageData(res.data);
        setChartData(chart);
        setResData(result.data);
      })
      .catch((err) => {
        if (!isMounted) return;
        setLoader(false);
        swal(`${err}`);
      });
  };

  const getDashbaordData1 = async (isMounted = true) => {
    let res = { data: { ...storageData } };

    try {
      res = await axios.get(api.api + "ImagesFromS3");
    } catch (err) {
      console.log(`${err}`);
    }

    axios
      .put(api.api + "OverviewDashbaord", inputData)
      .then((result) => {
        if (!isMounted) return;

        const chart = [["Result", "Number Of Reports"]];
        chart.push(["OK", result.data.OK_Inspection]);
        chart.push(["NG", result.data.NG_Inspection]);

        setStorageData(res.data);
        setChartData(chart);
        setResData(result.data);
      })
      .catch((err) => {
        if (!isMounted) return;
        console.log(`${err}`);
      });
  };

  const getColumnChartData = () => {
    const allData = { ...resData };
    const data = [
      ["Inspection|ItemName||ItemNumber||Operation", "Number Of Alerts", { role: "style" }],
    ];

    const options = {
      title: "Number Of Alerts / Inspection Type",
      height: 400,
      bar: { groupWidth: "95%" },
      legend: { position: "none" },
    };

    allData.Alerts.forEach((one) => {
      if (one._id) {
        data.push([
          `${one._id.Inspection}|${one._id.ItemName}|${one._id.ItemNumber}|${one._id.Operation}`,
          one.count || 0,
          "rgb(62 103 207)",
        ]);
      }
    });

    return { options, data };
  };

  const getNotificationTypeChartData = () => {
    const allData = { ...resData };
    const data = [["Result", "Number Of Reports"]];
    const options = {
      title: "Number Of Notification Type",
    };

    allData.AlertTypes.forEach((one) => {
      if (one._id) {
        data.push([`${one._id.DocumentType}`, one.count || 0]);
      }
    });

    return { options, data };
  };

  const getFolderStorageData = () => {
    const data = { ...storageData };
    const chart = [["Space Name", "Size(In Mb)"]];
    let test = [...data.ImagesByFolder];

    test.forEach((element) => {
      chart.push([element.Folder, element.Size / (1024 * 1024)]);
    });

    chart.push([
      "Free Space",
      data.TotalSizeAlloted - data.TotalSize / (1024 * 1024),
    ]);

    return chart;
  };


  function formatSize(bytes) {
    const mb = bytes / (1024 * 1024);
    if (mb >= 1024) {
        const gb = mb / 1024;
        return `${gb.toFixed(2)} GB`;
    } else {
        return `${mb.toFixed(2)} MB`;
    }
}

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {loader && <Loading labelShow={true} label={"Loading..."} />}
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <RangePicker
              disabled={inputData.IsLive}
              value={[moment(inputData.From), moment(inputData.Till)]}
              onChange={(dates, dateStrings) => {
                setInputData((prev) => ({
                  ...prev,
                  From: new Date(dateStrings[0]),
                  Till: new Date(dateStrings[1]),
                }));
              }}
            />

            <AntdButton
              disabled={inputData.IsLive}
              onClick={() => getDashbaordData()}
              type="primary"
            >
              Apply
            </AntdButton>

            <Checkbox
              checked={inputData.IsLive}
              onChange={(e) => {
                localStorage.setItem("islive", e.target.checked ? 1 : 0);
                const data = cloneDeep(inputData);
                data.IsLive = e.target.checked;
                setInputData(data);
              }}
            >
              Live
            </Checkbox>
          </div>
        </Header>

        <Content style={{ margin: "20px" }}>
          <Row gutter={[16, 16]}>
            {["TotalInspection", "SubmittedInspection", "NonSubmittedInspection", "PendingInspection"].map((key, i) => (
              <Col xs={24} sm={12} md={6} key={i}>
                <Card>
                  <Statistic title={key.replace(/([A-Z])/g, ' $1')} value={resData[key] || 0} />
                </Card>
              </Col>
            ))}
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={24} md={12}>
              <Card>
                {chartData.length > 1 ? (
                  <Chart
                    chartType="PieChart"
                    data={chartData}
                    options={{ title: "Number Of Inspection Result" }}
                    width={"100%"}
                  />
                ) : (
                  <p>No Data</p>
                )}
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card>
                <Chart
                  chartType="PieChart"
                  data={getNotificationTypeChartData().data}
                  options={getNotificationTypeChartData().options}
                  width={"100%"}
                />
              </Card>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={48} md={24}>
              <Card>
                {getColumnChartData().data.length > 1 ? (
                  <Chart
                    chartType="ColumnChart"
                    width="100%"
                    data={getColumnChartData().data}
                    options={getColumnChartData().options}
                  />
                ) : (
                  <p>No Alert Data Available</p>
                )}
              </Card>
            </Col>
          </Row>

          <Row gutter={[8, 8]} style={{ marginTop: "20px" }}>
            <Col xs={48} md={24}>
              <Card style={{ borderRadius: 10, padding: 8 }}>
                <Grid container spacing={1} sx={{ padding: 0.5, margin: 0, backgroundColor: "#000" }}>
                  <Grid item xs={24} md={12}>
                    <Paper
                      style={{
                        backdropFilter: "blur(5px)",
                        backgroundColor: "#ffffff2b",
                        color: "white",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 8,
                      }}
                      elevation={3}
                    >
                      <Typography style={{ fontSize: '22px', color: 'orange' }}>
                        {/* {`${isNaN((storageData.TotalSize / (1024 * 1024)).toFixed(2))
                          ? 0
                          : (storageData.TotalSize / (1024 * 1024)).toFixed(2)} MB / ${storageData.TotalSizeAlloted || 0} MB`}
                      */}
                       {`Used Space: ${formatSize(storageData.UsedDbSize || 0)} `}
                      </Typography>
                    </Paper>
                  </Grid>

                  {/* <Grid item xs={12} md={8}>
                    <Paper
                      style={{
                        backdropFilter: "blur(5px)",
                        backgroundColor: "#ffffff2b",
                        color: "white",
                        padding: 8,
                        height: "100%",
                      }}
                      elevation={3}
                    >
                      <Typography
                        className="fs-6 mb-1"
                        style={{ color: "white", fontWeight: "bold" }}
                      >
                        DISK SPACE (IN MB)
                      </Typography>
                      <Chart
                        chartType="PieChart"
                        data={getFolderStorageData()}
                        options={{
                          height: 180,
                          chartArea: { width: "90%", height: "80%" },
                          backgroundColor: "#2b2b2b",
                          legend: {
                            position: "right",
                            textStyle: { color: "#FFFFFF", fontSize: 10 },
                          },
                        }}
                        width="100%"
                      />
                    </Paper>
                  </Grid> */}
                </Grid>
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default OverviewDashboard;
